import { useEffect } from 'react';
import { LocationService } from '../services/location-service';
import { locationCacheService } from '../services/location-cache-service';

/**
 * Hook para precargar datos de ubicación en segundo plano
 * Se ejecuta cuando la aplicación se inicia para mejorar la experiencia del usuario
 */
export const useLocationPreload = () => {
  useEffect(() => {
    // Precargar datos de ubicación en segundo plano
    const preloadLocationData = async () => {
      try {
        // Cargar caché desde localStorage
        locationCacheService.loadFromStorage();
        
        // Si no tenemos provincias en caché, las precargamos
        const cachedProvinces = locationCacheService.getProvinces();
        if (!cachedProvinces) {
          const locationService = new LocationService();
          
          // Precargar provincias en segundo plano (sin mostrar loading)
          locationService.getProvinces(
            undefined,
            () => {
              // Los datos se guardan automáticamente en caché por el servicio
            },
            (error) => {
              console.warn('Error al precargar provincias:', error);
            }
          );
        }
      } catch (error) {
        console.warn('Error en precarga de ubicaciones:', error);
      }
    };

    // Ejecutar precarga después de un pequeño delay para no bloquear la UI inicial
    const timeoutId = setTimeout(preloadLocationData, 1000);
    
    return () => clearTimeout(timeoutId);
  }, []);
};

/**
 * Hook para precargar ciudades de provincias populares
 * Útil si sabes que ciertas provincias se usan frecuentemente
 */
export const usePopularCitiesPreload = (popularProvinceIds: number[] = [1, 2, 3]) => {
  useEffect(() => {
    const preloadPopularCities = async () => {
      try {
        const locationService = new LocationService();
        
        // Precargar ciudades de provincias populares
        popularProvinceIds.forEach(provinceId => {
          const cachedCities = locationCacheService.getCities(provinceId);
          if (!cachedCities) {
            locationService.getCitiesByProvince(
              provinceId,
              () => {},
              (error) => {
                console.warn(`Error al precargar ciudades para provincia ${provinceId}:`, error);
              }
            );
          }
        });
      } catch (error) {
        console.warn('Error en precarga de ciudades populares:', error);
      }
    };

    // Ejecutar después de que se hayan cargado las provincias
    const timeoutId = setTimeout(preloadPopularCities, 2000);
    
    return () => clearTimeout(timeoutId);
  }, [popularProvinceIds]);
};
